export default {
  name: "vip"
};